/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useState } from 'react';
import { KakarikoText } from '../Text';
import { StyledKakarikoDates } from './styles';
import type { IKakarikoDatesProps } from './types';

const twoNumberDate = (value?: string) => {
  if (!value) return '';
  return value.length === 1 ? `0${value}` : value;
};

export const defaultErrorMessage = 'Please input a valid date.';

const min = 1;
const max = [12, 31, 9999];

export const KakarikoDates = (props: IKakarikoDatesProps) => {
  const {
    className = '',
    errorMessage = defaultErrorMessage,
    handleBlur,
    handleChange,
    hasError,
    isEditable,
    isEditing = true,
    label,
    value,
    variant = 'filled',
    styles = {},
  } = props;

  const [day, setDay] = useState(value?.day);
  const [month, setMonth] = useState(value?.month);
  const [year, setYear] = useState(value?.year);
  const dates = [
    {
      label: 'Month',
      value: month,
      setFn: setMonth,
    },
    {
      label: 'Day',
      value: day,
      setFn: setDay,
    },
    {
      label: 'Year',
      value: year,
      setFn: setYear,
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [touched, setTouched] = useState(dates.map((d) => false));

  const handleBlurInternal = useCallback(
    (index: number) => {
      if (handleBlur) handleBlur({ day, month, year });
      let t = [...touched];
      t[index] = true;
      setTouched(t);
    },
    [day, month, touched, year, handleBlur, setTouched],
  );

  const handleChangeInternal = useCallback(
    (day, month, year) => {
      if (handleChange) handleChange({ day, month, year });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [day, month, year],
  );

  useEffect(() => {
    handleChangeInternal(day, month, year);
  }, [day, month, year, handleChangeInternal]);

  const setLocalValue = (
    localSetFn: Function,
    value: string | undefined | (string | undefined)[],
  ) => {
    localSetFn(value);
  };

  return (
    <StyledKakarikoDates className={className} style={styles}>
      <p>{label}</p>
      {isEditing && isEditable !== false ? (
        <div className="dates composed">
          {dates.map((date, index) => (
            <KakarikoText
              key={index}
              handleBlur={(e) => {
                handleBlurInternal(index);
                setLocalValue(date.setFn, e);
              }}
              handleChange={(e) => setLocalValue(date.setFn, e)}
              hasError={hasError && hasError[date.label.toLowerCase()]}
              label={date.label}
              name={date.label}
              min={min}
                max={max[index]}
              styles={{ width: '6rem' }}
              type="number"
              value={date.value || ''}
              variant={variant}
            />
          ))}
        </div>
      ) : (
        <div>
          <p>
              {year}-{twoNumberDate(month)}-{twoNumberDate(day)}
          </p>
        </div>
      )}
      {hasError &&
        (hasError.day || hasError.month || hasError.year) &&
        errorMessage &&
        touched.every((t) => !!t) && (
          <div className="error">{errorMessage}</div>
        )}
    </StyledKakarikoDates>
  );
};
